import { apiRequest } from './client';
import type {
  ActivityPublicDto,
  CodePublicDto,
  CodeShareRow,
  CreatorPublicDto,
  EarningsMonthRow,
  EarningsSeriesPoint,
  PaginatedSubscribers,
  PayoutMethodPublicDto,
  PayoutPublicDto,
  TaxDocumentPublicDto,
  TotalsDto,
} from './types';

export interface SubscriberQuery {
  status?: 'all' | 'active' | 'paused' | 'churned';
  code?: string;
  q?: string;
  sort?: 'joined' | 'months' | 'earned' | 'code' | 'status' | 'plan' | 'country';
  dir?: 'asc' | 'desc';
  page?: number;
  pageSize?: number;
}

export const creatorApi = {
  me(): Promise<CreatorPublicDto> {
    return apiRequest('/creators/me');
  },

  listCodes(): Promise<CodePublicDto[]> {
    return apiRequest('/creators/me/codes');
  },

  requestSideCode(input: { code: string; label: string }): Promise<CodePublicDto> {
    return apiRequest('/creators/me/codes', { method: 'POST', body: input });
  },

  totals(): Promise<TotalsDto> {
    return apiRequest('/creators/me/totals');
  },

  earningsSeries(range: '3M' | '6M' | '12M' | 'all'): Promise<EarningsSeriesPoint[]> {
    return apiRequest('/creators/me/earnings/series', { query: { range } });
  },

  earningsMonths(year: number): Promise<EarningsMonthRow[]> {
    return apiRequest('/creators/me/earnings/months', { query: { year } });
  },

  earningsCodeShare(): Promise<CodeShareRow[]> {
    return apiRequest('/creators/me/earnings/code-share');
  },

  payouts(): Promise<PayoutPublicDto[]> {
    return apiRequest('/creators/me/payouts');
  },

  payoutMethod(): Promise<PayoutMethodPublicDto | null> {
    return apiRequest('/creators/me/payouts/method');
  },

  updatePayoutMethod(body: unknown): Promise<PayoutMethodPublicDto> {
    return apiRequest('/creators/me/payouts/method', { method: 'PUT', body });
  },

  taxDocs(): Promise<TaxDocumentPublicDto[]> {
    return apiRequest('/creators/me/tax-documents');
  },

  taxDocDownload(id: number): Promise<{ url: string; expiresInSec: number }> {
    return apiRequest(`/creators/me/tax-documents/${id}/download`);
  },

  subscribers(q: SubscriberQuery): Promise<PaginatedSubscribers> {
    return apiRequest('/creators/me/subscribers', { query: q as Record<string, any> });
  },

  activity(limit = 5): Promise<ActivityPublicDto[]> {
    return apiRequest('/creators/me/activity', { query: { limit } });
  },
};
